module.exports = __webpack_public_path__ + "static/media/facebook.33d69b77.svg";